import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {SubscriptionsService} from './subscriptions.service';
import * as globals from '../settings';
import {LotteriesService} from '../lotteries.service';
import {GetPaymentMethodsService} from '../shared/paymentMethod/get-payment-methods.service';
import {UserService} from './user.service';

@Injectable()
export class LogoutService {
  user: any;

  constructor(private router: Router,
              private subscriptionsService: SubscriptionsService,
              private gpm: GetPaymentMethodsService,
              private userService: UserService,
              public lotteryService: LotteriesService) {
  }

  public loggedInCheck() {
    const dataString = localStorage.getItem('playerDetails');
    this.user = JSON.parse(dataString);

    if (this.user) {
      const sendData = {};
      sendData['sessionId'] = this.user.sessionId;
      this.lotteryService
        .postData
        (globals.appDomain + '/user/details/' + this.user.MemberID +
          '/userDetails.json', this.lotteryService.getFormUrlEncoded(sendData))
        .subscribe(
          result => {
              if (result.message.ErrorID) {
                this.logOut();
              } else {
                  const loggedInUser = result.message;
                  loggedInUser.sessionId = this.user.sessionId;
                  loggedInUser.memberId = this.user.memberId;
                  localStorage.setItem('playerDetails', JSON.stringify(loggedInUser));
                  this.subscriptionsService.updateBalance(loggedInUser.TotalBalance);
                  this.userService.getUser();
              }
          }
        );
    }
  }

  logOut() {
    localStorage.removeItem('virtualLogin');
    const sessionId = 'sessionId=' + this.user.sessionId;
    this.lotteryService.postData(globals.appDomain + '/user/logout/userLogout_nav.json', sessionId)
      .subscribe(
        data => {
          localStorage.removeItem('playerDetails');
          localStorage.removeItem('freshAddedPaymentMethodId');
          localStorage.removeItem('cart');
          localStorage.removeItem('tempCart');
          localStorage.setItem('knownUser', 'true');
          this.subscriptionsService.updateCart(0);
          this.subscriptionsService.emitIsLoggedIn(false);
          this.router.navigate(['/']);
            this.gpm.gpm_tmp = false;
            this.lotteryService.destroy.next();
            this.lotteryService.destroy.complete();
            this.subscriptionsService.emitGetPaymentMethods(false);
        }
      );
  }

}
